import React from 'react'
import { Platform } from 'react-native'
import { SvgXml } from 'react-native-svg'

export const SvgIcon = (props: {
  src: any
  size?: string | number
  color?: string
  viewBox?: string
  style?: any
}) => {
  const { color, src, size, viewBox, style } = props
  if (Platform.OS === 'web') {
    return (
      <img
        style={{ position: 'relative', zIndex: 9999, ...style }}
        src={`data:image/svg+xml;base64,${btoa(src?.data)}`}
        alt=""
        width={size}
        height={size}
      />
    )
  }
  return (
    <SvgXml
      override={{
        height: size || 48,
        width: size || 24,
        fill: color,
        viewBox,
      }}
      xml={src.data}
    />
  )
}
